import { t } from 'i18next';
import type { I18nPrefix } from '../../../i18n/prefix';
import type { DashboardPageProps } from '../../../lib/dashboard-page';
import { AuthLayout } from '../components/auth-layout';
import { AuthLogo } from '../components/auth-logo';
import { RegisterForm } from '../components/register-form';
import { ReturnToLoginLink } from '../components/return-to-login-link';

const PAGE = 'features:auth.pages.register_page' satisfies I18nPrefix;

export function RegisterPage({ handlers }: DashboardPageProps) {
  const { navigationHandler } = handlers;

  return (
    <AuthLayout>
      <div className="mx-auto w-full max-w-lg sm:mt-4 sm:max-w-xl">
        <AuthLogo className="h-9 w-auto lg:mb-8" />
        <div className="flex flex-wrap lg:flex-nowrap lg:justify-between">
          <div className="relative order-1 mt-8 min-w-full flex-1 rounded-md bg-white p-10 shadow-xl sm:order-0 sm:min-w-0 sm:flex-auto sm:p-14 lg:mt-0">
            <div>
              <div>
                <h2 className="mb-4 font-bold text-[26px] text-gray-900 leading-[1.2] sm:text-[32px]">
                  {t(`${PAGE}.heading`)} <br />
                  <span className="bg-linear-to-r from-fuchsia-500 to-cyan-500 bg-clip-text text-indigo-500">
                    {t(`${PAGE}.heading_highlight`)}
                  </span>
                </h2>
                <p className="max-w mt-2 text-gray-600 text-sm leading-6">
                  {t(`${PAGE}.description`)}
                </p>
              </div>

              <div className="mt-6">
                <RegisterForm handlers={handlers} />
              </div>
              <div className="absolute bottom-0 left-0 h-4 w-full rounded-b-md bg-linear-to-r from-indigo-500 via-purple-500 to-pink-500" />
            </div>
          </div>
        </div>
        <ReturnToLoginLink navigationHandler={navigationHandler} />
      </div>
    </AuthLayout>
  );
}
